import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-parent-list',
  templateUrl: './../../../templates/forms/modals/parent-list.component.html',
})
export class ParentListComponent implements OnInit {
  @Input()
  ACC_NO: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();


  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ParentListGrid"

  dataObj: any;
  parentList: any[] = [];
  searchFields: any[] = ['nature_name', 'nature_code'];
  public searchString;
  constructor(public dataService: CommonService,
    public langService: LangService, public gridService: GridService) {
    this.colObj = [
      { headerName: 'Parent Name', field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
      { headerName: 'Account Code', field: 'ACC_CODE', sortable: true, filter: true, resizable: true, hide: false },
      { headerName: 'Acc No', field: 'ACC_NO', sortable: true, filter: true, resizable: true, hide: false }

    ];
  }

  ngOnInit() {

    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForParent)
      .subscribe(arg => { this.parentList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false; 
    this.dataObj=_item;
    this.submit.next();
  }

}
